import React from 'react';
import { useCategoryTourManagement } from './useCategoryTourManagement';
import NavBarContainer from 'client/containers/NavBarContainer';
import Footer from 'client/containers/Footer';
import './_CategoryTourManagement.scss';

const CategoryTourManagement: React.FC = () => {
  const {
    allCategoryTours,
    isFormOpen,
    editingCategory,
    formData,
    handleOpenCreateForm,
    handleOpenEditForm,
    handleCloseForm,
    handleInputChange,
    handleSubmit,
    handleDelete,
  } = useCategoryTourManagement();

  return (
    <>
      <NavBarContainer />
      <div className="category-tour-management-container">
        <div className="category-tour-header">
          <h1>Gestion des Catégories de Tours</h1>
          <button className="btn-primary" onClick={handleOpenCreateForm}>
            + Créer une nouvelle catégorie
          </button>
        </div>

        {/* Liste des catégories */}
        <div className="category-tour-list">
          {allCategoryTours?.categoryTours && allCategoryTours.categoryTours.length > 0 ? (
            <div className="category-grid">
              {allCategoryTours.categoryTours.map((category) => (
                <div key={category._id} className="category-card">
                  <div className="category-card-header">
                    <h3>{category.name}</h3>
                    <span className="category-slug">{category.slug}</span>
                  </div>
                  <p className="category-description">{category.description}</p>
                  <div className="category-meta">
                    <small>
                      Créé par: <strong>{category.addedBy.username}</strong>
                    </small>
                    {category.createdAt && (
                      <small>
                        Le: {new Date(category.createdAt).toLocaleDateString('fr-FR')}
                      </small>
                    )}
                  </div>
                  <div className="category-actions">
                    <button
                      className="btn-edit"
                      onClick={() => handleOpenEditForm(category)}
                    >
                      Modifier
                    </button>
                    <button
                      className="btn-delete"
                      onClick={() => handleDelete(category._id)}
                    >
                      Supprimer
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-categories">
              <p>Aucune catégorie de tour trouvée.</p>
              <button className="btn-primary" onClick={handleOpenCreateForm}>
                Créer la première catégorie
              </button>
            </div>
          )}
        </div>

        {/* Modal de formulaire */}
        {isFormOpen && (
          <div className="modal-overlay" onClick={handleCloseForm}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>
                  {editingCategory
                    ? 'Modifier la catégorie'
                    : 'Créer une nouvelle catégorie'}
                </h2>
                <button className="modal-close" onClick={handleCloseForm}>
                  ×
                </button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Nom de la catégorie *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    placeholder="Ex: Aventure, Culture, Nature..."
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="description">Description *</label>
                  <textarea
                    id="description"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    required
                    rows={4}
                    placeholder="Décrivez cette catégorie de tour..."
                  />
                </div>
                <div className="form-actions">
                  <button type="button" className="btn-secondary" onClick={handleCloseForm}>
                    Annuler
                  </button>
                  <button type="submit" className="btn-primary">
                    {editingCategory ? 'Mettre à jour' : 'Créer'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default CategoryTourManagement;
